export let gridRenderStartTime: number | null = null;

export function setGridRenderStartTime() {
  gridRenderStartTime = performance.now();
}

export function getGridRenderDurationAndReset(): number | null {
  if (gridRenderStartTime !== null) {
    console.log("start time: " + gridRenderStartTime);
    console.log("end time: " + performance.now());
    const duration = performance.now() - gridRenderStartTime;
    gridRenderStartTime = null;
    return duration;
  }
  return null;
}
export const PAGE_SIZE = 80;



// WEBPACK FOOTER //
// ./src/views/OptionsView/util.ts